import { ADVISORY_SEVERITY_APPEARANCE, ADVISORY_STATUS_APPEARANCE, DEFAULT_APPEARANCE, MATCH_OP_LABELS } from '../../../../constants/firmware-advisories';
import { findComponentTypeById } from '../../../../helpers/hardwareInventory';

/*
 * How an advisory reads on screen: the label for a row and the badge appearances.
 *
 * Kept dependency-free on purpose: `moment` and `_` are webpack ProvidePlugin globals and are not
 * defined when mocha loads this module, so anything reachable from a test must not rely on them.
 */

export const advisoryMatcherSummary = (advisory) => {
	const parts = [
		['manufacturer', advisory?.manufacturerMatch],
		['model', advisory?.modelMatch]
	]
		.filter(([, match]) => {
			return Boolean(match?.value);
		})
		.map(([field, match]) => {
			return `${field} ${MATCH_OP_LABELS[match.op] ?? match.op} ${match.value}`;
		});

	return parts.join(' · ');
};

/*
 * The catalog is an inner join on the fleet analytics table, so an advisory can legitimately point
 * at a component type that is not in the list. Falling back to the matcher says what the advisory
 * targets rather than leaving the cell blank.
 */
export const advisoryDisplayName = (advisory, componentTypes) => {
	const componentType = findComponentTypeById(advisory?.componentTypeId, componentTypes);

	if (componentType?.displayName) {
		return componentType.displayName;
	}

	return advisoryMatcherSummary(advisory) || advisory?.componentTypeId || '';
};

export const severityAppearance = (severity) => {
	return ADVISORY_SEVERITY_APPEARANCE[severity] ?? DEFAULT_APPEARANCE;
};

export const statusAppearance = (status) => {
	return ADVISORY_STATUS_APPEARANCE[status] ?? DEFAULT_APPEARANCE;
};
